import { $patchStyleText } from '@lexical/selection';
import { $getSelection, $isRangeSelection } from 'lexical';
import React from 'react';
import ResponsiveToolbar from '../../components/ResponsiveToolbar';
import { Icons } from '../../icons/Icons';
import { FONT_FAMILIES, fontFamilyKey, LexicalToolbarProps } from '../lexicalConstants';

export default function LexicalFontMenu({
    disabled = false,
    editor,
    currentFont
}: LexicalToolbarProps & { currentFont: string | null }) {
    const handleFontChange = (fontFamily: string | null) => {
        if (fontFamily) {
            editor.update(() => {
                const selection = $getSelection();
                if ($isRangeSelection(selection)) {
                    $patchStyleText(selection, {
                        [fontFamilyKey]: fontFamily
                    });
                }
            });
        }
    };

    return (
        <ResponsiveToolbar
            disabled={disabled}
            multi={false}
            isSmall
            options={FONT_FAMILIES}
            onSelect={handleFontChange}
            selected={currentFont}
            icon={Icons.FontTitle}
        />
    );
}
